import React, { useState, useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import {
  Row, Col, Typography, Card, Form, Button, message,
  Input,
} from 'antd';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { getUserMail, getUserType } from '../../../../../utils/users';
import UploadFiles from '../../../serviceComponents/uploadFiles/UploadFiles';
import { SessionExpiredException } from '../../../../../utils/errors';
import { isItEstimateOrService } from '../../../../../utils/service';
import {
  post, get, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../../dataSource/requests';
import './Summary.scss';

const Summary = (props) => {
  const [formInstance] = Form.useForm();
  const navigate = useNavigate();
  const userType = getUserType();

  const uploadFilesReference = useRef(null);
  const [valueAttachmentSizeCooperated, setValueAttachmentSizeCooperated] = useState(null);

  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState(null);

  const titleOrcamento = useRef(false);

  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const {
    serviceRequestParameters, nextPage, previousPage,
  } = props;

  /**
   * Identificar qual o e-mail do usuário logado e que está fazendo a solicitação da operação
   * @returns se o usuário for do perfil cooperado o e-mail estará validado e será exibido
   */
  const userMailCooperative = () => {
    const targetMail = getUserMail() ? getUserMail().replaceAll('"', '') : '-';

    return (
      <div>
        <div>
          <span>{`Email: ${userType === 'COOPERATIVE' ? targetMail : '-'}`}</span>
        </div>
        <div>
          <span style={{ fontSize: '.7rem' }}>(caso esteja incorreto, informar e-mail válido no campo observação)</span>
        </div>
      </div>
    );
  };

  const getLabel = (idCode, value) => {
    switch (idCode) {
      case 'POS_VENDA_LOCACAO_DE_PILOTO_MUNICIPIO':
        return 'Qual o município em que se encontra o equipamento';

      case 'POS_VENDA_LOCACAO_DE_PILOTO_MODELO':
        return 'Modelo';

      case 'POS_VENDA_LOCACAO_DE_PILOTO_PERIODO_DESEJADO':
        return 'Período desejado';

      case 'POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO':
        if (value === '') return '';
        return 'Início';

      case 'POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM':
        if (value === '') return '';
        return 'Fim';

      case 'POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM':
        return 'Tipo de ordem';

      case 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO':
        if (value === '') return '';
        return 'Valor unitário';

      case 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL':
        if (value === '') return '';
        return 'Valor total';

      case 'POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO':
        if (value === '') return '';
        return 'Condição de pagamento';

      case 'POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO':
        if (value === '') return '';
        return 'Forma de pagamento';

      case 'POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES':
        if (value === '') return '';
        return 'Observações do orçamento';

      default:
        return '';
    }
  };

  const getField = (idCodeParameter) => {
    return serviceRequestParameters
      .serviceRequestFieldInputList
      .find(
        (field) => {
          return field.idCode === idCodeParameter;
        },
      );
  };

  const printValue = (idCode, value) => {
    switch (true) {
      case (value === true):
      case (value === 'true'):
        return 'Sim';

      case (value === false):
      case (value === 'false'):
        return 'Não';

      case (value?._isAMomentObject):
        return value.format('DD/MM/YYYY');

      case (/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z/.test(value)):
        return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').format('DD/MM/YYYY');

      case (idCode === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO' && value !== ''):
        return currencyFormatter.format(value);

      case (idCode === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL' && value !== ''):
        return currencyFormatter.format(value);

      default:
        return value;
    }
  };

  const renderField = (idCodeParameter) => {
    const field = getField(idCodeParameter);

    if (field !== undefined) {
      if (idCodeParameter === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO' && field.value !== '') {
        titleOrcamento.current = true;
      }

      if (field.value !== '') {
        return (
          <Row
            className="LocacaoPilotoSummary__DetailRow"
          >
            <Col
              span={24}
              className="LocacaoPilotoSummary__DetailParentColumn"
            >

              {
                idCodeParameter === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO' && field.value !== ''
                && (
                  <>
                    <hr />
                    <p className="LocacaoPilotoSummary__SessionTitle">Orçamento</p>
                  </>
                )
              }

              {
                titleOrcamento.current === false
                && idCodeParameter === 'POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES'
                && field.value !== ''
                && (
                  <>
                    <hr />
                    <p className="LocacaoPilotoSummary__SessionTitle">Orçamento</p>
                  </>
                )
              }

              <Row
                justify="space-between"
                className="LocacaoPilotoSummary__DetailChildRow"
              >
                <Col
                  className="LocacaoPilotoSummary__DetailColumn"
                >
                  {getLabel(idCodeParameter, field.value)}
                </Col>
                <Col
                  className="LocacaoPilotoSummary__DetailSpecificColumn"
                >
                  {printValue(idCodeParameter, field.value)}
                </Col>
              </Row>
            </Col>
          </Row>
        );
      }
    }

    return null;
  };

  const mask = (rawValue) => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getAttachmentParamenters = async () => {
    try {
      const requestRef: RequestWrapper = get({
        url: '/system/getAttachmentParamenters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const response = await requestRef;

      setValueAttachmentSizeCooperated(
        response?.body.getAttachmentParamentersOutput.attachmentSizeCooperated,
      );
    } catch (error) {
      message.error('Ocorreu um erro ao buscar informações, tente novamente');
    }
  };

  useEffect(() => {
    getAttachmentParamenters();
    return () => {
      setLoading(false);
    };
  }, []);

  const onFormFinish = async (values) => {
    setLoading(true);
    let response;

    let telValue = values.TelInput;
    telValue = !telValue ? '' : telValue.replace(/\D/g, '');

    const data = {
      landFieldsIds: (serviceRequestParameters.talhoesSelecionados
        ? serviceRequestParameters.talhoesSelecionados.map((v) => v.id) : []),
      landId: serviceRequestParameters.selectedProperty.id,
      landOwnerId: serviceRequestParameters.selectedOwner.id,
      serviceId: serviceRequestParameters.selectedService.id,
      cooperativeNotes: values.observacao,
      telephone: telValue,
      serviceTypeId: serviceRequestParameters.selectedType.id,
      haveCtc: serviceRequestParameters.haveCtc,
      ctc: serviceRequestParameters.ctc,
      branchCoopercitrusId: serviceRequestParameters.branchCoopercitrusId,
    };

    const newFieldsInputList = serviceRequestParameters.serviceRequestFieldInputList.filter((i) => { return i.idCode !== 'intervalPeriod'; });

    if (userType === 'COOPERATIVE') {
      newFieldsInputList.push({
        idCode: 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO',
        value: '',
      });
      newFieldsInputList.push({
        idCode: 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL',
        value: '',
      });
      newFieldsInputList.push({
        idCode: 'POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO',
        value: '',
      });
      newFieldsInputList.push({
        idCode: 'POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO',
        value: '',
      });
      newFieldsInputList.push({
        idCode: 'POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES',
        value: '',
      });
    }

    let targetUrl = '';
    if (serviceRequestParameters.choiceServiceType === 1) {
      targetUrl = '/budget/requestBudgetService';
      data.budgetRequestFieldInputs = newFieldsInputList;
    } else {
      targetUrl = '/service/requestService';
      data.serviceRequestFieldInputList = newFieldsInputList;
    }

    try {
      const requestRef: RequestWrapper = post({
        url: targetUrl,
        params: data,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
      }
      setLoading(false);
      return;
    }

    if (!response?.body.error) {
      if (response?.body.code === 5002) {
        flushSync(() => {
          setRequestId(response?.body.createServiceRequestOutput.serviceRequestId);
        });
      } else {
        flushSync(() => {
          setRequestId(response?.body.createBudgetOutput.budgetId);
        });
      }

      const uploadError = !uploadFilesReference.current.validateFiles();
      if (!uploadError) {
        try {
          await uploadFilesReference.current.handleSubmitFiles();
        } catch (error) {
          setLoading(false);
          return;
        }

        nextPage({});
      }
    } else if (response?.body.code === -6006) {
      message.error('Esta cultura não é válida para este serviço');
    } else {
      message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
    }

    setLoading(false);
  };

  return (
    <div className="LocacaoPilotoSummary">
      <Row
        justify="space-between"
        className="LocacaoPilotoSummary__TitleRow"
      >
        <Col
          className="LocacaoPilotoSummary__TitleCol"
        >
          <Typography.Title
            level={1}
            className="LocacaoPilotoSummary__Title"
          >
            Resumo da Solicitação
          </Typography.Title>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="LocacaoPilotoSummary__ContentRow"
      >
        <Col
          span={24}
          className="LocacaoPilotoSummary__ContentColumn"
        >
          <Card
            className="LocacaoPilotoSummary__ContentCard"
          >
            <Form
              scrollToFirstError
              className="LocacaoPilotoSummary__Form"
              form={formInstance}
              onFinish={onFormFinish}
              layout="vertical"
              onFinishFailed={
                (errorInfo) => {
                  console.log('grid summary form finish failed:', errorInfo);
                }
              }
            >
              <Row
                gutter={[24, 24]}
                className="LocacaoPilotoSummary__DetailsRow"
              >
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="LocacaoPilotoSummary__DetailsColumn"
                >
                  <Row
                    gutter={[24, 24]}
                    className="LocacaoPilotoSummary__ServiceTitleRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__ServiceTitleCol"
                    >
                      <Typography.Title
                        level={1}
                        className="LocacaoPilotoSummary__ServiceFullTitle"
                      >
                        <span className="LocacaoPilotoSummary__ServiceTitle">{'Pós-vendas: '}</span>
                        <span className="LocacaoPilotoSummary__ServicesTypeTitle">Locação de Piloto</span>
                      </Typography.Title>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__MatriculaRow"
                  >
                    <Col
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__MatriculaColumn"
                      xs={{ span: 24 }}
                    >
                      {`Matrícula: ${serviceRequestParameters.selectedProperty.matriculation}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__CooperadoRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__CooperadoColumn"
                    >
                      {`Cooperado: ${serviceRequestParameters.selectedOwner.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__PropriedadeColumn"
                    >
                      {`Propriedade: ${serviceRequestParameters.selectedProperty.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__PropriedadeColumn"
                    >
                      {
                        userMailCooperative()
                      }
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__PropriedadeColumn"
                    >
                      <span>{`Possui CTC: ${serviceRequestParameters.haveCtc ? 'Sim' : 'Não'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__PropriedadeColumn"
                    >
                      <span>{`CTC: ${serviceRequestParameters.ctc ? serviceRequestParameters.ctc : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailRow LocacaoPilotoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__PropriedadeColumn"
                    >
                      <span>{`Filial: ${serviceRequestParameters.branchName ? serviceRequestParameters.branchName : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__DetailsRow LocacaoPilotoSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__DetailColumn LocacaoPilotoSummary__PropriedadeColumn"
                    >
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO_MUNICIPIO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO_MODELO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO_PERIODO_DESEJADO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM')}
                      {userType === 'COOPERCITRUS' && renderField('POS_VENDA_LOCACAO_DE_PILOTO_TIPO_ORDEM')}

                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO')}
                      {renderField('POS_VENDA_LOCACAO_DE_PILOTO-OBSERVACOES')}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__PhoneRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__PhoneColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="LocacaoPilotoSummary__PhoneTitle"
                      >
                        Telefone para contato
                      </Typography.Title>
                      <Form.Item
                        name="TelInput"
                        className="LocacaoPilotoSummary__PhoneFormItem"
                        validateTrigger={['onBlur']}
                        rules={[
                          {
                            required: true,
                            message: 'Por favor, insira um telefone.',
                          },
                          {
                            min: 14,
                            message: 'Telefone inválido',
                          },
                        ]}
                      >
                        <MaskedInput
                          guide={false}
                          mask={mask}
                          placeholder="Telefone"
                          className="ant-input LocacaoPilotoSummary__PhoneMaskedInput"
                          maxLength={15}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__CommentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__CommentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="LocacaoPilotoSummary__CommentsTitle"
                      >
                        Observação
                      </Typography.Title>
                      <Form.Item
                        className="LocacaoPilotoSummary__CommentsFormItem"
                        name="observacao"
                        rules={[
                          {
                            max: 1000,
                            message: 'A observação deve ter no máximo 1000 caractéres',
                          },
                        ]}
                      >
                        <Input.TextArea
                          className="obsArea LocacaoPilotoSummary__CommentsInput"
                          xs={{ span: 24 }}
                          lg={{ span: 10 }}
                          rows={4}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="LocacaoPilotoSummary__AttachmentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="LocacaoPilotoSummary__AttachmentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="LocacaoPilotoSummary__AttachmentsTitle"
                      >
                        Imagens do equipamento
                      </Typography.Title>
                      <Form.Item
                        name="anexo"
                        className="LocacaoPilotoSummary__AttachmentsFormItem"
                      >
                        <div className="attachments-items-container">
                          <UploadFiles
                            ref={uploadFilesReference}
                            origin="summary"
                            requestType={
                              isItEstimateOrService(
                                serviceRequestParameters.choiceServiceType === 1 ? 'ORCAMENTO' : 'SERVICO',
                                userType,
                              )
                            }
                            typeUser="SERVICE_REQUEST_CUSTOMER_FILE"
                            action="edit"
                            id={requestId}
                            fileSize={valueAttachmentSizeCooperated}
                            initialFiles={
                              [].map((item) => ({ ...item, uid: item.id, status: 'done' }))
                            }
                          />
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="LocacaoPilotoSummary__GeomapColumn"
                >
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                justify="end"
                className="LocacaoPilotoSummary__ButtonRow"
              >
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="LocacaoPilotoSummary__ButtonFirstColumn"
                >
                  <Button
                    block
                    className="LocacaoPilotoSummary__BackButton"
                    onClick={() => previousPage()}
                    loading={loading}
                  >
                    <ArrowLeftIcon className="LocacaoPilotoSummary__ArrowLeftIcon" />
                    Voltar
                  </Button>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="LocacaoPilotoSummary__ButtonSecondColumn"
                >
                  <Form.Item
                    className="LocacaoPilotoSummary__ContinueButtonFormItem"
                  >
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="LocacaoPilotoSummary__ContinueButton"
                      loading={loading}
                    >
                      Confirmar Solicitação
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Summary.propTypes = {
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    haveCtc: PropTypes.bool,
    ctc: PropTypes.string,
    branchCoopercitrusId: PropTypes.number,
    choiceServiceType: PropTypes.number,
    branchName: PropTypes.string,

    serviceTypeDynamicFields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        idCode: PropTypes.string,
      }),
    ).isRequired,

    serviceSubtypeDynamicFields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        idCode: PropTypes.string,
      }),
    ).isRequired,

    service: PropTypes.string,

    serviceRequestFieldInputList: PropTypes.arrayOf(
      PropTypes.shape({
        idCode: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.instanceOf(moment),
          PropTypes.bool,
        ]),
      }),
    ),

    selectedProperty: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      registeredOn: PropTypes.instanceOf(moment),
      matriculation: PropTypes.string,

      location: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    selectedService: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    selectedOwner: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Summary.defaultProps = {};

export default Summary;
